import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    token: null,
    user: null,
    featureAccess: null, // Initialize as null
  });

  const [clientLoginformData, setClientLoginFormData] = useState({
    header_text: 'Ai Human',
    button_color: '#eb8d16',
    logo_url: '',
    background_image_url: '',
  });
  const [loading, setLoading] = useState(true);

  const [tempToken, setTempTokenState] = useState(() => localStorage.getItem('tempToken') || '');

  const setTempToken = token => {
    setTempTokenState(token);
    if (token) {
      localStorage.setItem('tempToken', token);
    } else {
      localStorage.removeItem('tempToken');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = Cookies.get('token');
      const user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;

      // Handle featureAccess safely
      let featureAccess = null;
      try {
        if (user?._id) {
          const response = await axios.get(`/auth/useraccess/${user._id}`);
          featureAccess = response.data.featureAccess; // Store the response data in featureAccess
        }
      } catch (e) {
        console.error('Error fetching featureAccess:', e);
        featureAccess = null;
      }

      if (token) {
        setAuthState({ token, user, featureAccess });
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const login = (token, userData, featureAccess) => {
    Cookies.set('token', token, { expires: 365 * 20 });
    Cookies.set('user', JSON.stringify(userData), { expires: 365 * 20 });

    // Normalize featureAccess - treat undefined as null
    const normalizedFeatureAccess = featureAccess ?? null;

    if (normalizedFeatureAccess) {
      Cookies.set('featureAccess', JSON.stringify(normalizedFeatureAccess), { expires: 365 * 20 });
    } else {
      Cookies.remove('featureAccess');
    }

    setAuthState({
      token,
      user: userData,
      featureAccess: normalizedFeatureAccess,
    });
  };

  const logout = () => {
    Cookies.remove('token');
    Cookies.remove('user');
    Cookies.remove('featureAccess');
    setAuthState({ token: null, user: null, featureAccess: null });
  };

  const clientverify = (client_url, status) => {
    Cookies.set(client_url, status, { expires: 365 * 20 });
    localStorage.setItem(client_url, 0);
  };

  return (
    <AuthContext.Provider
      value={{
        authState,
        login,
        logout,
        loading,
        clientverify,
        setTempToken,
        tempToken,
        setAuthState,
        setClientLoginFormData,
        clientLoginformData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
